
const triggerChange = (element) => {
  let changeEvent = new Event('change');
  element.dispatchEvent(changeEvent);
}

export { triggerChange };
